// extracted by mini-css-extract-plugin
export default {"tx":"_6a5056bab7","line":"f3539ad6e2"};